var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23381_30800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23381_30800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.119 -2.59355e-09L2.88095 -2.73005e-10C1.56599 -1.22228e-10 0.5 1.07452 0.5 2.4L0.5 15.6C0.5 16.9255 1.56599 18 2.88095 18L23.119 18C24.434 18 25.5 16.9255 25.5 15.6L25.5 2.4C25.5 1.07452 24.434 -2.74432e-09 23.119 -2.59355e-09Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23381_30800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.119 -2.59355e-09L2.88095 -2.73005e-10C1.56599 -1.22228e-10 0.5 1.07452 0.5 2.4L0.5 15.6C0.5 16.9255 1.56599 18 2.88095 18L23.119 18C24.434 18 25.5 16.9255 25.5 15.6L25.5 2.4C25.5 1.07452 24.434 -2.74432e-09 23.119 -2.59355e-09Z",
    fill: "#002EA3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12L25.5 12L25.5 18L0.5 18L0.5 12Z",
    fill: "#F4A900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0L25.5 -2.86655e-09L25.5 6L0.5 6L0.5 0Z",
    fill: "#DC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.119 0.599976L2.88093 0.599976C1.89471 0.599976 1.09521 1.40586 1.09521 2.39998L1.09521 15.6C1.09521 16.5941 1.89471 17.4 2.88093 17.4L23.119 17.4C24.1052 17.4 24.9047 16.5941 24.9047 15.6L24.9047 2.39998C24.9047 1.40586 24.1052 0.599976 23.119 0.599976Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23381_30800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm);
export default __webpack_public_path__ + "static/media/AM.914a3be876427c638792cf702bbb7240.svg";
export { ForwardRef as ReactComponent };